<div class="text-grey-400 fx-col fx-align-center min-h-full">
  <header class="w-full text-center main-header text-white">
    <h1>{{ 'i18n.Welcome.MainTitle' | translate }}</h1>
  </header>

  <customer-header-options class="section p-3 mx-auto">
    <customer-header-options-item
      *ngIf="currentLang$ | async as lang"
      id="language"
      tooltip
      class="text-capitalize ml-auto"
      tooltipMode="click"
      [tooltipTemplate]="languageTemplate"
      [tooltipPosition]="tooltipsTemplatePosition">
      <mat-icon
        *ngIf="lang.src"
        slot="icon-only"
        [svgIcon]="lang.id">
      </mat-icon>
      <span id="language-label">{{ lang.id }}</span>
    </customer-header-options-item>
  </customer-header-options>

  <section class="section dashboard-access">
    <div class="content mb-auto">
      <h2>{{ 'i18n.Welcome.DashboardAccessTitle' | translate }}</h2>
      <p>{{ 'i18n.Welcome.DashboardAccessDescription' | translate }}</p>
    </div>
    <div class="images">
      <div class="carousel">
        <button
          class="prev"
          (click)="prevImage('dashboard')">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="image-wrapper">
          <img
            [src]="dashboardImages[dashboardImageIndex]"
            alt="Dashboard Image"
          />
        </div>
        <button
          class="next"
          (click)="nextImage('dashboard')">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </section>


  <footer class="px-3 mt-auto bg-white py-3 w-full">
    <p class="px-3 text-center">
      © Zucchetti Centro Sistemi S.p.a. - Tutti i diritti riservati. - P.I.01262190513 C.F. 03225010481
      <a
        class="mx-3 border-l-1 px-3 border-grey-400"
        href="https://www.zcsazzurro.com/it/privacy-policy" target="_blank">
        Privacy Policy
      </a>
    </p>
  </footer>
</div>


<ng-template #languageTemplate>
  <customer-language-selector></customer-language-selector>
</ng-template>
